import { render, staticRenderFns } from "./UserEditEmailModal.vue?vue&type=template&id=3a8ed983&scoped=true&"
import script from "./UserEditEmailModal.vue?vue&type=script&lang=js&"
export * from "./UserEditEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ed983",
  null
  
)

export default component.exports